import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "uploadBtn" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("选择文件")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "  ", -1)
const _hoisted_4 = {
  key: 3,
  class: "d-flex justify-content--center"
}
const _hoisted_5 = { style: {"color":"black","text-align":"center"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "共导入", -1)
const _hoisted_7 = { class: "ml-5 mr-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "个，", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "成功", -1)
const _hoisted_10 = { class: "ml-5 mr-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "个，", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "失败", -1)
const _hoisted_13 = {
  class: "ml-5 mr-5",
  style: {"color":"var(--el-color-danger)"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "个", -1)
const _hoisted_15 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 您可以下载失败数据，修改后再重新导入 ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("下载失败数据")

import {ElMessage, ElMessageBox} from 'element-plus'
import {ref, Ref, watch} from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
    upParams: null,
    upConfig: { type: [Array, Boolean] },
    upFetch: null,
    check: null,
    result: null,
    dialogTitle: null,
    importText: null,
    btnText: null,
    showBtn: { type: Boolean },
    confirmBtn: null
  },
  emits: ['beforeUp', 'upSuccess', 'visible'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  upParams: any
  upConfig?: FromConfig[] | boolean
  upFetch: (form: any, obj: object) => any,//上传接口
  check: (res: object) => Promise<boolean>,//上传后检查方法
  result: {
    completed: boolean,
    total: number,
    successCount: number,
    failureCount: number,
    downloadErrors: () => any
  },
  //文字
  dialogTitle?: string,
  importText?: string,
  btnText?: string,
  showBtn?: boolean,
  confirmBtn: {
    text: string,
    loadingText: string,
  },
}




const {dialogTitle = '上传', btnText = "批量导入", importText = "正在导入", showBtn = false, upConfig = false} = props

const formEle = ref()
const upload = ref()
const uploadFg: Ref<boolean> = ref(false)
const upVisiable: Ref<boolean> = ref(false)
watch(upVisiable, (cur, old) => {
  emits("visible", cur)
})
const showDialog=()=>{
  setTimeout(()=>{
    upload.value.clearFiles()
    fileList = []
  },50)
  uploadFg.value=false
  upVisiable.value= true
}

const handleExceed = (files: any) => {
  upload.value.clearFiles()
  upload.value.handleStart(files[0])
}

let fileList: any = []
const submitUpload = () => {
  if (fileList.length === 0) {
    // 如果没有选择文件
    ElMessage.warning({message: '请选择文件', grouping: true})
    return
  }
  upload.value!.submit()
}

const customUpFetch = async (file: any) => {


  const form = new FormData();
  form.append("file", file.file);

  Object.keys(props.upParams).map(_key => {
    form.append(_key, props.upParams[_key]);
  })

  if (formEle.value && upConfig) {
    let _formParams = formEle.value.submitHandle()
    try {
      await _formParams.then((rep: any) => {
        Object.keys(rep).map(_key => {
          form.append(_key, rep[_key]);
        })
      })
    } catch (error) {
    }
    /* Object.keys(_formParams).map(_param => {
        form.append(_param, _formParams[_param]);
    }) */
  }

  uploadFg.value = true
  try {
    let upFileRespond = await props.upFetch(form, {timeout:  60000})
    // upVisiable.value = false
    ElMessage.success(importText)
    // emits('upSuccess', upFileRespond)
    check(upFileRespond).then(()=>{})
  } catch (error) {
    upload.value.clearFiles()
    fileList = []
    ElMessage.error("导入失败：" + error)
  }
}
//调用接口检查 异步导入的结果，每隔5秒检查一次结果，直到导入完成
const check = async (res: any) => {
  const completed = await props.check(res)
  if (!completed) {
    setTimeout(() => {
      check(res)
    }, 5000)
  }
}

let onChange = (file: any, files: any) => {
  fileList = files
}

const downloadErrors = () => {
  props.result.downloadErrors()
}


return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (!_unref(showBtn))
      ? (_openBlock(), _createBlock(_component_el_link, {
          key: 0,
          type: "primary",
          onClick: showDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(btnText)), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(showBtn))
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          onClick: showDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(btnText)), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      class: "async-upload-dialog",
      "append-to-body": true,
      "close-on-click-modal": false,
      title: _unref(dialogTitle),
      modelValue: upVisiable.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((upVisiable).value = $event)),
      center: ""
    }, _createSlots({
      default: _withCtx(() => [
        (!__props.result.completed)
          ? _renderSlot(_ctx.$slots, "default", { key: 0 })
          : _createCommentVNode("", true),
        (_unref(upConfig) && upVisiable.value&&!__props.result.completed)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (upVisiable.value && _unref(upConfig))
                ? (_openBlock(), _createBlock(_component_FlexibleForm, _mergeProps({
                    key: 0,
                    ref_key: "formEle",
                    ref: formEle
                  }, {
                    searchConfig: _unref(upConfig),
                    showSubmit: false
                }), null, 16))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (upVisiable.value&&!__props.result.completed)
          ? (_openBlock(), _createBlock(_component_el_upload, _mergeProps({
              key: 2,
              ref_key: "upload",
              ref: upload,
              action: '',
              limit: 1,
              "on-exceed": handleExceed,
              "auto-upload": false,
              "http-request": customUpFetch,
              "on-change": _unref(onChange),
              class: "mt-10"
            }, _ctx.$attrs), {
              trigger: _withCtx(() => [
                _createVNode(_component_el_button, {
                  icon: "UploadFilled",
                  disabled: uploadFg.value
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              tip: _withCtx(() => [
                _renderSlot(_ctx.$slots, "tip")
              ]),
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 3
            }, 16, ["on-change"]))
          : _createCommentVNode("", true),
        (__props.result.completed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("span", _hoisted_7, _toDisplayString(__props.result.total), 1),
                  _hoisted_8,
                  _hoisted_9,
                  _createElementVNode("span", _hoisted_10, _toDisplayString(__props.result.successCount), 1),
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("span", _hoisted_13, _toDisplayString(__props.result.failureCount), 1),
                  _hoisted_14
                ]),
                (__props.result.failureCount>0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_el_link, {
                        type: "primary",
                        class: "ml-5",
                        onClick: downloadErrors
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (!__props.result.completed)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: submitUpload,
                loading: uploadFg.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(uploadFg.value.value ? __props.confirmBtn.loadingText : __props.confirmBtn.text), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          }
        : undefined
    ]), 1032, ["title", "modelValue"])
  ]))
}
}

})